import commonHelper from '@/app/utility/common.helper.utility';
import XLSX from 'xlsx';
import URL_UTILITY from '../../../../../../utility/url.utility';

export default {
  name: 'generateComparative',
  props: [
    'roundData',
    'roundProps',
    'itemBasis',
    'rfpHeaderId',
    'negotiationSequence'
  ],
  computed: {
    unitPriceFields() {
      return this.generateComparativeFieldsForBoq.filter(field =>
        field.key.includes('_unit_price')
      );
    }
  },
  data() {
    return {
      generateComparativeData: [],
      generateComparativeFields: [],
      locationName: {
        value: null,
        text: null
      },
      options: [],
      currentPage: 1,
      perPage: commonHelper.perPageRecordData,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      rfpBasis: null,
      popoverContent: null,
      requestId: null,
      templateId: null,
      requestStatus: null,
      reqId: null,
      dowloadReport: URL_UTILITY.getDownloadReportUrl,
      boqFlag: false,
      generateComparativeDataForBoq: [],
      generateComparativeFieldsForBoq: [],
      boqComparativeApiData: [],
      variation: null,
      vendorComparisonData: []
    };
  },
  watch: {
    currentPage: function() {
      this.getGenerateComparative();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getGenerateComparative();
    }
  },
  mounted() {
    let locations = this.$store.state.rfp.rfpState;
    this.options = locations;
    this.rfpBasis = this.itemBasis;
  },
  methods: {
    getData(inputData) {
      const names = inputData[0].comp_detail.split('|');
      const dataArray = inputData
        .slice(1)
        .map(obj => obj.comp_detail.split('|'));
      const result = dataArray.map(data => {
        return data.reduce((acc, value, index) => {
          acc[names[index]] = value;
          return acc;
        }, {});
      });
      this.generateComparativeData = result;
      let arr = [];
      for (let i of result) {
        for (let key in i) {
          if (key.includes('F_V') || key.includes('I_V')) {
            i[key] = +i[key];
          }
        }
      }
      for (let i of result) {
        let array = [];
        for (let key in i) {
          if (key.includes('F_V')) {
            array.push(i[key]);
          }
        }
        let smallest = Infinity;
        for (let j = 0; j < array.length; j++) {
          if (+array[j] < +smallest) {
            smallest = +array[j];
          }
        }
        arr.push(smallest);
      }
      for (let i = 0; i < this.generateComparativeData.length; i++) {
        for (let key in this.generateComparativeData[i]) {
          if (key.includes('F_V')) {
            let cellValue = +this.generateComparativeData[i][key];
            if (cellValue === arr[i]) {
              let cellVariantKey = key;
              if (!this.generateComparativeData[i]['_cellVariants']) {
                this.$set(this.generateComparativeData[i], '_cellVariants', {});
              }
              this.$set(
                this.generateComparativeData[i]._cellVariants,
                cellVariantKey,
                'success'
              );
            }
          }
        }
      }
      setTimeout(() => {
        this.generateComparativeData = JSON.parse(
          JSON.stringify(this.generateComparativeData)
        );
      }, 0);
    },
    downloadExcelData(type) {
      this.makeToast('Excel Sheet downloading!', 'success');
      if (type === 'item') {
        const ws = XLSX.utils.json_to_sheet(this.generateComparativeData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Comparative');
        XLSX.writeFile(wb, 'comparative.xlsx');
      } else {
        const columnHeaders = this.generateComparativeFieldsForBoq.map(
          field => field.label
        );
        let excelData = this.generateComparativeDataForBoq.map(row => {
          let formattedRow = {};
          this.generateComparativeFieldsForBoq.forEach(field => {
            formattedRow[field.label] = row[field.key] || '-';
          });
          return formattedRow;
        });
        const ws = XLSX.utils.json_to_sheet(excelData, {
          header: columnHeaders
        });
        ws['!cols'] = columnHeaders.map(() => ({ wch: 20 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'BOQ Comparison');
        XLSX.writeFile(wb, 'BOQ_Comparison.xlsx');
      }
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: 'Alert',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true,
        toastClass: 'custom-toast',
        autoHideDelay: 2000
      });
    },
    getCellClass(value) {
      if (value === 'Red') return 'bg-danger';
      if (value === 'Green') return 'bg-success';
      if (value === 'Blue') return 'bg-primary';
      return '';
    },
    getGenerateComparative() {
      if (this.itemBasis === 'item') {
        this.boqFlag = false;
        let payload = {
          rfp_header_id: this.rfpHeaderId,
          negotiation_seq: this.negotiationSequence
        };
        this.loading = true;
        this.$store
          .dispatch('rfp/getRfpNewComparative', payload)
          .then(response => {
            this.loading = false;
            if (response.status === 200) {
              let result = response.data.data;
              this.boqComparativeApiData = result;
              this.processDataForDetailItems();
              // let totalAmount = 0;
              // for(let i of this.generateComparativeData) {
              //   i.amount = +i.quantity * +i.unit_price
              //   totalAmount = totalAmount + i.amount;
              // }
              // this.generateComparativeData.push({
              //   location_name: 'Total',
              //   cost_centre: null,
              //   item_code: null,
              //   item_description: null,
              //   quantity: null,
              //   name: null,
              //   negotiation_seq: null,
              //   version: null,
              //   unit_price: null,
              //   amount: totalAmount,
              //   attributes: null
              // })
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (this.itemBasis === 'BOQ') {
        this.boqFlag = true;
      }
    },
    getKeySummaryDtls(value) {
      const payload = {
        tag: value,
        menu_id: this.$store.state.shared.menuId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getKeySummaryDtls', payload)
        .then(resp => {
          this.loader = false;
          this.helpModal = true;
          if (resp.status === 200) {
            let result = resp.data.data;
            this.popoverContent = result;
          } else {
            this.helpText = 'Something Went Wrong.';
          }
        })
        .catch(() => {
          this.helpModal = true;
          this.loader = false;
          this.helpText = 'Something Went Wrong.';
        });
    },
    downloadPdf() {
      const payload = {
        template_name: 'RFP_ITEM_COMPARISON'
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getRfpReqId', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.requestId = resp.data.data.request_id;
            this.templateId = resp.data.data.template_id;
            this.saveSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    saveSubmitRequest() {
      const payload = {
        admin_submit_req_details: [
          {
            request_num: 0,
            request_id: this.requestId,
            template_id: this.templateId,
            schedule_type: 'asap', //pass hardcode
            request_start_date: null,
            request_end_date: null,
            resubmit_interval: null,
            resubmit_interval_unit: null,
            day_of_month: null,
            day_of_week: null,
            output_format_id: 'PDF', //pass hardcode
            no_of_args: 25,
            request_parameter:
              this.rfpHeaderId + ',' + this.negotiationSequence,
            sms_flag: false,
            email_flag: false,
            whatsapp_flag: false,
            child_req_count: null,
            email_comm_template_id: null,
            sms_comm_template_id: null,
            whatsapp_comm_template_id: null,
            argument1: this.rfpHeaderId,
            argument2: this.negotiationSequence,
            argument3: null,
            argument4: null,
            argument5: null,
            argument6: null,
            argument7: null,
            argument8: null,
            argument9: null,
            argument10: null,
            argument11: null,
            argument12: null,
            argument13: null,
            argument14: null,
            argument15: null,
            argument16: null,
            argument17: null,
            argument18: null,
            argument19: null,
            argument20: null,
            argument21: null,
            argument22: null,
            argument23: null,
            argument24: null,
            argument25: null
          }
        ]
      };
      this.loader = true;
      this.$store
        .dispatch('template/saveSubmitRequest', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 201) {
            this.requestNumId = resp.data.data[0].id;
            this.getSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getSubmitRequest() {
      this.loader = true;
      this.$store
        .dispatch('template/getSubmitRequest', this.requestNumId)
        .then(resp => {
          // this.loader = false;
          if (resp.status === 200) {
            this.requestStatus = resp.data.data[0].status;
            this.reqId = resp.data.data[0].id;
            if (this.requestStatus === 'ERROR') {
              this.loader = false;
              this.requestStatus = null;
              alert('Request in ERROR can not Preview');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    downloadReport() {
      window.location.href = this.dowloadReport + '/' + this.reqId;
      this.requestStatus = null;
    },
    processDataForDetail() {
      this.generateComparativeFieldsForBoq = [
        {
          key: 'sheet_name',
          label: 'Sheet Name',
          class: 'narrow-col'
        },
        {
          key: 'r_number',
          label: 'Row No',
          class: 'narrow-col'
        },
        {
          key: 's_number',
          label: 'Serial No',
          class: 'narrow-col'
        },
        {
          key: 'negotiation_seq',
          label: 'Round',
          class: 'narrow-col'
        },
        {
          key: 'location_name',
          label: 'Location',
          class: 'narrow-col'
        },
        {
          key: 'boq_line_code',
          label: 'Activity Code',
          class: ''
        },
        {
          key: 'boq_line_subcode',
          label: 'Subcode',
          class: ''
        },
        {
          key: 'boq_description',
          label: 'Description',
          class: 'col-fix-wrap'
        },
        {
          key: 'uom',
          label: 'UOM',
          class: 'narrow-col'
        },
        {
          key: 'boq_quantity',
          label: 'Quantity',
          class: 'text-right col-wrap'
        }
      ];
      let vendors = new Set();
      this.boqComparativeApiData.forEach(item => {
        item.vendor_unit_price_details.forEach(vendor => {
          vendors.add(vendor.vendor_name);
        });
      });
      vendors.forEach(vendor => {
        this.generateComparativeFieldsForBoq.push(
          {
            key: `${vendor}_unit_price`,
            label: `${vendor} Unit Price (INR)`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_total_amount`,
            label: `${vendor} Total Amount`,
            class: 'text-right col-wrap'
          }
        );
      });
      let totalsRow = {
        sheet_name: 'Total',
        _rowVariant: 'info',
        rowClass: 'font-weight-bold'
      };
      this.generateComparativeDataForBoq = this.boqComparativeApiData.map(
        item => {
          let row = { ...item };
          vendors.forEach(vendor => {
            let vendorData = item.vendor_unit_price_details.find(
              v => v.vendor_name === vendor
            );
            row[`${vendor}_unit_price`] = vendorData
              ? `${Number(vendorData.unit_price).toFixed(2)}`
              : '-';

            row[`${vendor}_total_amount`] = vendorData
              ? `${Number(vendorData.total_amount).toFixed(2)}`
              : '-';
            totalsRow[`${vendor}_total_amount`] =
              (totalsRow[`${vendor}_total_amount`] || 0) +
              (vendorData ? Number(vendorData.total_amount) : 0);
          });

          return row;
        }
      );
      vendors.forEach(vendor => {
        if (totalsRow[`${vendor}_total_amount`] !== undefined) {
          totalsRow[`${vendor}_total_amount`] = `${totalsRow[
            `${vendor}_total_amount`
          ].toFixed(2)}`;
        }
      });
      this.generateComparativeDataForBoq.push(totalsRow);
    },
    truncateString(souce, size) {
      return commonHelper.truncate(souce, size);
    },
    getBoqComparative(type) {
      if (type === 'detail') {
        this.getBoqDetailComparative();
      } else if (type === 'grand') {
        this.getBoqGrandSummaryComparative();
      } else if (type === 'activityCode') {
        this.getBoqActivityCodeSummaryComparative();
      } else if (type === 'median') {
        this.getMedianComparative();
      }
    },
    getBoqDetailComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId,
        negotiation_seq: this.negotiationSequence
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getBoqGenerateComparative', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            for (let i of this.boqComparativeApiData) {
              i.boq_quantity = Number(i.boq_quantity).toFixed(2);
            }
            this.processDataForDetail();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBoqGrandSummaryComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId,
        negotiation_seq: this.negotiationSequence
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getGrandSummaryComparative', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            this.processDataForSheetSummary();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // processDataForSheetSummary() { // 1.2 (Himanshu) commented for a new function
    //   this.generateComparativeDataForBoq = [];
    //   this.generateComparativeFieldsForBoq = [
    //     { key: 'sheet_name', label: 'Sheet Name', class: '' }
    //   ];
    //   let vendorNames = new Set();
    //   let totalsRow = { sheet_name: 'Total', _rowVariant: 'info' };
    //   this.boqComparativeApiData.forEach(sheet => {
    //     sheet.vendor_details_summ_comp.forEach(vendor => {
    //       vendorNames.add(vendor.vendor_name);
    //     });
    //   });
    //   let vendorArray = Array.from(vendorNames);
    //   vendorArray.forEach(vendor => {
    //     this.generateComparativeFieldsForBoq.push({
    //       key: vendor,
    //       label: `${vendor}
    //       Total Amount (INR)`,
    //       class: 'text-right'
    //     });
    //     totalsRow[vendor] = 0;
    //   });
    //   this.boqComparativeApiData.forEach(sheet => {
    //     let row = { sheet_name: sheet.sheet_name };
    //     vendorArray.forEach(vendor => {
    //       let vendorData = sheet.vendor_details_summ_comp.find(
    //         v => v.vendor_name === vendor
    //       );
    //       let totalAmount =
    //         vendorData && vendorData.total_amount !== null
    //           ? Number(vendorData.total_amount)
    //           : 0;
    //       row[vendor] =
    //         vendorData && vendorData.total_amount !== null
    //           ? `${vendorData.total_amount.toFixed(2)}`
    //           : '0';
    //       totalsRow[vendor] += totalAmount;
    //     });

    //     this.generateComparativeDataForBoq.push(row);
    //   });
    //   vendorArray.forEach(vendor => {
    //     totalsRow[vendor] = `${totalsRow[vendor].toFixed(2)}`;
    //   });
    //   this.generateComparativeDataForBoq.push(totalsRow);
    // },
    processDataForSheetSummary() { // 1.2 (Himanshu) new function for processDataForSheetSummary
  this.generateComparativeDataForBoq = [];
  this.generateComparativeFieldsForBoq = [
    { key: 'sheet_name', label: 'Sheet Name', class: '' }
  ];
  let vendorNames = new Set();
  let totalsRow = { sheet_name: 'Total', _rowVariant: 'info' };
  this.boqComparativeApiData.forEach(sheet => {
    sheet.vendor_details_summ_comp.forEach(vendor => {
      vendorNames.add(vendor.vendor_name);
    });
  });
  let vendorArray = Array.from(vendorNames);
  vendorArray.forEach(vendor => {
    this.generateComparativeFieldsForBoq.push({
      key: vendor,
      label: `${vendor} Total Amount (INR)`,
      class: 'text-right'
    });
    this.generateComparativeFieldsForBoq.push({
      key: vendor + "_cost_per_area",
      label: `${vendor} Cost/Area`,
      class: 'text-right'
    });
    totalsRow[vendor] = 0;
    totalsRow[vendor + "_cost_per_area"] = 0;
  });
  this.boqComparativeApiData.forEach(sheet => {
    let row = { sheet_name: sheet.sheet_name };
    vendorArray.forEach(vendor => {
      let vendorData = sheet.vendor_details_summ_comp.find(
        v => v.vendor_name === vendor
      );
      let totalAmount =
        vendorData && vendorData.total_amount !== null
          ? Number(vendorData.total_amount)
          : null;
      row[vendor] =
        totalAmount !== null ? totalAmount.toFixed(2) : null;
      let costPerArea =
        vendorData && vendorData.cost_per_area_sheetwise !== null
          ? Number(vendorData.cost_per_area_sheetwise)
          : null;
      row[vendor + "_cost_per_area"] =
        costPerArea !== null ? costPerArea.toFixed(2) : null;
      if (totalAmount !== null) {
        totalsRow[vendor] += totalAmount;
      }
      if (costPerArea !== null) {
        totalsRow[vendor + "_cost_per_area"] += costPerArea;
      }
    });

    this.generateComparativeDataForBoq.push(row);
  });
  vendorArray.forEach(vendor => {
    totalsRow[vendor] =
      totalsRow[vendor] !== 0 ? totalsRow[vendor].toFixed(2) : null;
    totalsRow[vendor + "_cost_per_area"] =
      totalsRow[vendor + "_cost_per_area"] !== 0
        ? totalsRow[vendor + "_cost_per_area"].toFixed(2)
        : null;
  });
  this.generateComparativeDataForBoq.push(totalsRow);
},
    getBoqActivityCodeSummaryComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId,
        negotiation_seq: this.negotiationSequence
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getActivityCodeSummaryComparative', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            this.processDataForActivityCodeSummary();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    processDataForActivityCodeSummary() {
      this.generateComparativeDataForBoq = [];
      this.generateComparativeFieldsForBoq = [
        { key: 'sheet_name', label: 'Sheet Name', class: '' },
        { key: 'boq_line_code', label: 'Activity Code', class: '' }
      ];

      let vendorNames = new Set();
      let totalsRow = {
        sheet_name: 'Total',
        boq_line_code: '-',
        _rowVariant: 'info'
      };
      this.boqComparativeApiData.forEach(sheet => {
        sheet.vendor_details_summ_comp.forEach(vendor => {
          vendorNames.add(vendor.vendor_name);
        });
      });
      let vendorArray = Array.from(vendorNames);
      vendorArray.forEach(vendor => {
        this.generateComparativeFieldsForBoq.push({
          key: vendor,
          label: `${vendor} 
          Total Amount (INR)`,
          class: 'text-right'
        });
        totalsRow[vendor] = 0;
      });
      this.boqComparativeApiData.forEach(sheet => {
        let row = {
          sheet_name: sheet.sheet_name,
          boq_line_code: sheet.boq_line_code
        };
        vendorArray.forEach(vendor => {
          let vendorData = sheet.vendor_details_summ_comp.find(
            v => v.vendor_name === vendor
          );
          let totalAmount = vendorData ? Number(vendorData.total_amount) : 0;

          row[vendor] = `${totalAmount.toFixed(2)}`;
          totalsRow[vendor] += totalAmount;
        });
        this.generateComparativeDataForBoq.push(row);
      });
      vendorArray.forEach(vendor => {
        totalsRow[vendor] = `${totalsRow[vendor].toFixed(2)}`;
      });
      this.generateComparativeDataForBoq.push(totalsRow);
    },
    processDataForDetailItems() {
      this.generateComparativeFields = [
        {
          key: 'rfp_number'
        },
        {
          key: 'item_code',
          label: 'Item Code'
        },
        {
          key: 'item_description',
          label: 'Item Description'
        },
        {
          key: 'item_long_description',
          label: 'Item Specification'
        },
        {
          key: 'location_name',
          label: 'Location Name'
        },
        {
          key: 'negotiation_seq',
          label: 'Round'
        },
        {
          key: 'quantity',
          label: 'Quantity'
        },
        {
          key: 'uom',
          label: 'UOM'
        }
      ];
      let vendors = new Set();
      this.boqComparativeApiData.forEach(item => {
        item.vendor_unit_price_details.forEach(vendor => {
          vendors.add(vendor.vendor_name);
        });
      });
      vendors.forEach(vendor => {
        this.generateComparativeFields.push(
          {
            key: `${vendor}_unit_price`,
            label: `${vendor} Unit Price (INR)`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_total_amount`,
            label: `${vendor} Total Amount`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_vendor_attributes`,
            label: `${vendor} Vendor Attributes`,
            class: 'text-right col-wrap'
          }
        );
      });
      let totalsRow = {
        item_code: 'Total',
        _rowVariant: 'info',
        rowClass: 'font-weight-bold'
      };
      this.generateComparativeData = this.boqComparativeApiData.map(item => {
        let row = { ...item };
        vendors.forEach(vendor => {
          let vendorData = item.vendor_unit_price_details.find(
            v => v.vendor_name === vendor
          );
          row[`${vendor}_unit_price`] = vendorData
            ? `${Number(vendorData.unit_price).toFixed(2)}`
            : '-';

          row[`${vendor}_total_amount`] = vendorData
            ? `${Number(vendorData.total_amount).toFixed(2)}`
            : '-';
          row[`${vendor}_vendor_attributes`] = vendorData
            ? `${vendorData.vendor_attributes}`
            : '-';
          totalsRow[`${vendor}_total_amount`] =
            (totalsRow[`${vendor}_total_amount`] || 0) +
            (vendorData ? Number(vendorData.total_amount) : 0);
        });

        return row;
      });
      vendors.forEach(vendor => {
        if (totalsRow[`${vendor}_total_amount`] !== undefined) {
          totalsRow[`${vendor}_total_amount`] = `${totalsRow[
            `${vendor}_total_amount`
          ].toFixed(2)}`;
        }
      });
      this.generateComparativeData.push(totalsRow);
    },
    getMedianComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId,
        negotiation_seq: this.negotiationSequence,
        variation: this.variation
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getMedianSummary', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            this.vendorComparisonData = response.data.data;
            this.processDataForMedian();
          } else {
            this.makeToast('Something went wrong', 'danger');
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // processDataForMedian() {
    //   this.generateComparativeDataForBoq = [];
    //   this.generateComparativeFieldsForBoq = [
    //     { key: 's_number', label: '', class: '' },
    //     { key: 'r_number', label: '', class: '' },
    //     { key: 'boq_description', label: '', class: '' },
    //     { key: 'uom', label: '', class: '' },
    //     { key: 'boq_quantity', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' },
    //     // { key: '', label: '', class: '' }
    //   ];

    //   let vendorNames = new Set();
    //   // let totalsRow = {
    //   //   sheet_name: 'Total',
    //   //   boq_line_code: '-',
    //   //   _rowVariant: 'info'
    //   // };
    //   this.boqComparativeApiData.forEach(sheet => {
    //     sheet.vendor_unit_price_median_details.forEach(vendor => {
    //       vendorNames.add(vendor.vendor_name);
    //     });
    //   });
    //   let vendorArray = Array.from(vendorNames);
    //   vendorArray.forEach(vendor => {
    //     this.generateComparativeFieldsForBoq.push({
    //       key: vendor,
    //       label: `${vendor}
    //       Total Amount (INR)`,
    //       class: 'text-right'
    //     });
    //     // totalsRow[vendor] = 0;
    //   });
    //   this.boqComparativeApiData.forEach(sheet => {
    //     let row = {
    //       sheet_name: sheet.sheet_name,
    //       boq_line_code: sheet.boq_line_code
    //     };
    //     vendorArray.forEach(vendor => {
    //       let vendorData = sheet.vendor_details_summ_comp.find(
    //         v => v.vendor_name === vendor
    //       );
    //       let totalAmount = vendorData ? Number(vendorData.total_amount) : 0;

    //       row[vendor] = `${totalAmount.toFixed(2)}`;
    //       // totalsRow[vendor] += totalAmount;
    //     });
    //     this.generateComparativeDataForBoq.push(row);
    //   });
    //   // vendorArray.forEach(vendor => {
    //   //   totalsRow[vendor] = `${totalsRow[vendor].toFixed(2)}`;
    //   // });
    //   // this.generateComparativeDataForBoq.push(totalsRow);
    // },
    // processDataForMedian() {
    //   this.generateComparativeFieldsForBoq = [
    //     { key: 'sr_no', label: 'Sr. No' },
    //     { key: 'r_number', label: 'Round No' },
    //     { key: 'boq_line_code', label: 'Description' },
    //     { key: 'uom', label: 'UOM' },
    //     { key: 'boq_quantity', label: 'Quantity' }
    //   ];

    //   const vendorSet = new Set();
    //   this.vendorComparisonData.forEach(item => {
    //     item.vendor_unit_price_median_details.forEach(v =>
    //       vendorSet.add(v.vendor_name)
    //     );
    //   });

    //   const vendorList = Array.from(vendorSet);

    //   vendorList.forEach(vendor => {
    //     this.generateComparativeFieldsForBoq.push({
    //       key: `${vendor}_unit_price`,
    //       label: `${vendor} Unit Price`,
    //       class: 'text-right'
    //     });
    //     this.generateComparativeFieldsForBoq.push({
    //       key: `${vendor}_amount`,
    //       label: `${vendor} Amount`,
    //       class: 'text-right'
    //     });
    //   });

    //   // Analytics columns
    //   this.generateComparativeFieldsForBoq.push({
    //     key: 'min_Price',
    //     label: 'Min Price',
    //     class: 'text-right'
    //   });
    //   this.generateComparativeFieldsForBoq.push({
    //     key: 'min_Amount',
    //     label: 'Min Amount',
    //     class: 'text-right'
    //   });
    //   this.generateComparativeFieldsForBoq.push({
    //     key: 'median_Price',
    //     label: 'Median Price',
    //     class: 'text-right'
    //   });
    //   this.generateComparativeFieldsForBoq.push({
    //     key: 'median_Upper_Bound',
    //     label: 'Median + Var%',
    //     class: 'text-right'
    //   });
    //   this.generateComparativeFieldsForBoq.push({
    //     key: 'median_Lower_Bound',
    //     label: 'Median - Var%',
    //     class: 'text-right'
    //   });

    //   this.generateComparativeDataForBoq = this.vendorComparisonData.map(
    //     item => {
    //       const row = {
    //         sr_no: item.s_number,
    //         r_number: item.r_number,
    //         boq_line_code: item.boq_line_code,
    //         uom: item.uom,
    //         boq_quantity: item.boq_quantity,
    //         min_Price: item.min_Price,
    //         min_Amount: item.min_Amount,
    //         median_Price: item.median_Price,
    //         median_Upper_Bound: item.median_Upper_Bound,
    //         median_Lower_Bound: item.median_Lower_Bound
    //       };

    //       vendorList.forEach(vendor => {
    //         const data = item.vendor_unit_price_median_details.find(
    //           v => v.vendor_name === vendor
    //         );
    //         if (data) {
    //           const className =
    //             data.unit_price > item.median_Price
    //               ? 'text-danger font-weight-bold'
    //               : data.unit_price < item.median_Price
    //               ? 'text-warning font-weight-bold'
    //               : '';

    //           row[
    //             `${vendor}_unit_price`
    //           ] = `<span class="${className}">${data.unit_price.toFixed(
    //             2
    //           )}</span>`;

    //           row[`${vendor}_amount`] = data.total_amount.toFixed(2);
    //         } else {
    //           row[`${vendor}_unit_price`] = { value: '-', class: '' };
    //           row[`${vendor}_amount`] = '-';
    //         }
    //       });

    //       return row;
    //     }
    //   );
    // }
    processDataForMedian() {
      this.generateComparativeFieldsForBoq = [
        {
          key: 'sheet_name',
          label: 'Sheet Name',
          class: 'col-fix-small text-left'
        },
        {
          key: 'r_number',
          label: 'Row No.',
          class: 'col-fix-small text-left'
        },
        { key: 'sr_no', label: 'Sr. No.', class: 'col-fix-small text-left' },
        {
          key: 'negotiation_seq',
          label: 'Round No.',
          class: 'col-fix-small text-left'
        },
        {
          key: 'location_name',
          label: 'Location',
          class: 'col-fix-small text-left'
        },
        { key: 'boq_line_code', label: 'Activity Code', class: '' },
        { key: 'boq_line_subcode', label: 'Subcode', class: '' },
        { key: 'boq_description', label: 'Desription', class: 'col-fix-wrap' },
        { key: 'uom', label: 'UOM', class: 'col-fix-small text-left' },
        {
          key: 'boq_quantity',
          label: 'Quantity',
          class: 'col-fix-small text-left'
        }
      ];

      const vendorSet = new Set();
      this.vendorComparisonData.forEach(item => {
        item.vendor_unit_price_median_details.forEach(v =>
          vendorSet.add(v.vendor_name)
        );
      });

      const vendorList = Array.from(vendorSet);

      vendorList.forEach(vendor => {
        this.generateComparativeFieldsForBoq.push({
          key: `${vendor}_unit_price_text`,
          label: `${vendor} Unit Price`,
          tdClass: (value, key, item) =>
            item[`${vendor}_unit_price_class`] || '',
          class: 'text-right'
        });
        this.generateComparativeFieldsForBoq.push({
          key: `${vendor}_amount`,
          label: `${vendor} Amount`,
          class: 'text-right'
        });
      });

      // Analytics columns
      this.generateComparativeFieldsForBoq.push(
        { key: 'min_Price', label: 'Min Price', class: 'text-right' },
        { key: 'min_Amount', label: 'Min Amount', class: 'text-right' },
        { key: 'median_Price', label: 'Median Price', class: 'text-right' },
        {
          key: 'median_Upper_Bound',
          label: 'Median + Var%',
          class: 'text-right'
        },
        {
          key: 'median_Lower_Bound',
          label: 'Median - Var%',
          class: 'text-right'
        }
      );

      this.generateComparativeDataForBoq = this.vendorComparisonData.map(
        item => {
          const row = {
            sheet_name: item.sheet_name,
            sr_no: item.s_number,
            r_number: item.r_number,
            negotiation_seq: item.negotiation_seq,
            location_name: item.location_name,
            boq_line_code: item.boq_line_code,
            boq_line_subcode: item.boq_line_subcode,
            boq_description: item.boq_description,
            uom: item.uom,
            boq_quantity: item.boq_quantity,
            min_Price: item.min_Price.toFixed(2),
            min_Amount: item.min_Amount.toFixed(2),
            median_Price: item.median_Price.toFixed(2),
            median_Upper_Bound: item.median_Upper_Bound.toFixed(2),
            median_Lower_Bound: item.median_Lower_Bound.toFixed(2)
          };

          vendorList.forEach(vendor => {
            const data = item.vendor_unit_price_median_details.find(
              v => v.vendor_name === vendor
            );

            if (data) {
              const unit_price = Number(data.unit_price);
              // const median = Number(item.median_Price);

              // Store value and class separately
              row[`${vendor}_unit_price_text`] = unit_price.toFixed(2);
              if (data.variation_flag === 'BELOW_VARIATION') {
                row[`${vendor}_unit_price_class`] =
                  'text-warning font-weight-bold';
              } else if (data.variation_flag === 'EQUAL_VARIATION') {
                row[`${vendor}_unit_price_class`] =
                  'text-success font-weight-bold';
              } else if (data.variation_flag === 'ABOVE_VARIATION') {
                row[`${vendor}_unit_price_class`] =
                  'text-danger font-weight-bold';
              }
              // row[`${vendor}_unit_price_class`] =
              //   unit_price > median
              //     ? 'text-danger font-weight-bold'
              //     : unit_price < median
              //     ? 'text-warning font-weight-bold'
              //     : '';
              row[`${vendor}_amount`] = data.total_amount.toFixed(2);
            } else {
              row[`${vendor}_unit_price_text`] = '-';
              row[`${vendor}_unit_price_class`] = '';
              row[`${vendor}_amount`] = '-';
            }
          });

          return row;
        }
      );
    }
  },
  beforeDestroy() {
    this.eventBus.$off('state');
  }
};
